import {
  useGetService,
  type UseGetServiceOptions,
} from "@libs/service-providers/api-service-provider";

import { ALERTS_SUMMARY_URL } from "./apiEndpoints";
import type { AlertsSummaryItem } from "./types";

type Options = Omit<UseGetServiceOptions<AlertsSummaryItem>, "route" | "queryKey">;

export const useGetAlertsSummary = (options?: Options) =>
  useGetService<AlertsSummaryItem>({
    route: ALERTS_SUMMARY_URL,
    queryKey: ["dq-dashboard", "alerts-summary"],
    retry: false,
    ...(options ?? {}),
  });
